module.exports = __webpack_public_path__ + "mobile-phone-format-2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/mobile-phone-format-2.mp4
// module id = 1162
// module chunks = 10